__turbopack_export_value__({
  "body-logo-18": "TestimonialItem-module-scss-module__H19xLG__body-logo-18",
  "body-text-12": "TestimonialItem-module-scss-module__H19xLG__body-text-12",
  "body-text-14": "TestimonialItem-module-scss-module__H19xLG__body-text-14",
  "body-text-16": "TestimonialItem-module-scss-module__H19xLG__body-text-16",
  "body-text-18": "TestimonialItem-module-scss-module__H19xLG__body-text-18",
  "body-text-20": "TestimonialItem-module-scss-module__H19xLG__body-text-20",
  "body-text-24": "TestimonialItem-module-scss-module__H19xLG__body-text-24",
  "body-text-24-2": "TestimonialItem-module-scss-module__H19xLG__body-text-24-2",
  "body-text-heading-2": "TestimonialItem-module-scss-module__H19xLG__body-text-heading-2",
  "body-text-heading-3": "TestimonialItem-module-scss-module__H19xLG__body-text-heading-3",
  "body-text-medium-14": "TestimonialItem-module-scss-module__H19xLG__body-text-medium-14",
  "body-text-medium-16": "TestimonialItem-module-scss-module__H19xLG__body-text-medium-16",
  "body-text-medium-18": "TestimonialItem-module-scss-module__H19xLG__body-text-medium-18",
  "body-text-medium2-18": "TestimonialItem-module-scss-module__H19xLG__body-text-medium2-18",
  "body-text2-14": "TestimonialItem-module-scss-module__H19xLG__body-text2-14",
  "body-text2-16": "TestimonialItem-module-scss-module__H19xLG__body-text2-16",
  "button-primary-text": "TestimonialItem-module-scss-module__H19xLG__button-primary-text",
  "button-text": "TestimonialItem-module-scss-module__H19xLG__button-text",
  "button2-text": "TestimonialItem-module-scss-module__H19xLG__button2-text",
  "card-shadow": "TestimonialItem-module-scss-module__H19xLG__card-shadow",
  "effect-menu": "TestimonialItem-module-scss-module__H19xLG__effect-menu",
  "header-1": "TestimonialItem-module-scss-module__H19xLG__header-1",
  "item": "TestimonialItem-module-scss-module__H19xLG__item",
  "item__answer": "TestimonialItem-module-scss-module__H19xLG__item__answer",
  "item__head": "TestimonialItem-module-scss-module__H19xLG__item__head",
  "item__name": "TestimonialItem-module-scss-module__H19xLG__item__name",
  "item__score": "TestimonialItem-module-scss-module__H19xLG__item__score",
  "item__scoreWrapper": "TestimonialItem-module-scss-module__H19xLG__item__scoreWrapper",
  "item__showMore": "TestimonialItem-module-scss-module__H19xLG__item__showMore",
  "item__text": "TestimonialItem-module-scss-module__H19xLG__item__text",
  "item__text_cropped": "TestimonialItem-module-scss-module__H19xLG__item__text_cropped",
  "main-container": "TestimonialItem-module-scss-module__H19xLG__main-container",
  "main-footer-container": "TestimonialItem-module-scss-module__H19xLG__main-footer-container",
  "main-header-container": "TestimonialItem-module-scss-module__H19xLG__main-header-container",
  "txt-12-bold": "TestimonialItem-module-scss-module__H19xLG__txt-12-bold",
  "txt-14-bold": "TestimonialItem-module-scss-module__H19xLG__txt-14-bold",
  "txt-14-bold-caps": "TestimonialItem-module-scss-module__H19xLG__txt-14-bold-caps",
  "txt-14-med": "TestimonialItem-module-scss-module__H19xLG__txt-14-med",
  "txt-16-bold": "TestimonialItem-module-scss-module__H19xLG__txt-16-bold",
  "txt-16-med": "TestimonialItem-module-scss-module__H19xLG__txt-16-med",
  "txt-18-bold": "TestimonialItem-module-scss-module__H19xLG__txt-18-bold",
  "txt-18-medium": "TestimonialItem-module-scss-module__H19xLG__txt-18-medium",
  "txt-18-medium-24": "TestimonialItem-module-scss-module__H19xLG__txt-18-medium-24",
  "txt-24-semi": "TestimonialItem-module-scss-module__H19xLG__txt-24-semi",
});
